import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { T_PREFIX } from '../utils';

interface Props {
    isOverviewTab?: boolean;
    title?: React.ReactNode;
}

export const GigServicesHeader = ({ isOverviewTab, title }: Props) => (
    <Stack direction="column" gap="2">
        <Typography size={{ default: 'h_sm', lg: isOverviewTab ? 'h_md' : 'h_sm' }} fontWeight="bold" color="grey_1200">
            {title || <I18n k={isOverviewTab ? `${T_PREFIX}.available_to_order` : `${T_PREFIX}.order_service`} />}
        </Typography>
    </Stack>
);
